import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';
import { setBooking } from './update';

export const fetchCurrentStarted = createAction('booking/fetchCurrentStarted');
export const fetchCurrentSucceeded = createAction(
  'booking/fetchCurrentSucceeded'
);
export const fetchCurrentFailed = createAction('booking/fetchCurrentFailed');

export const fetchCurrent = (bookingId) => (dispatch) => {
  const endpoint = bookingId
    ? EcomEngineAPI.booking.getBookingById
    : EcomEngineAPI.booking.current;

  dispatch(fetchCurrentStarted());

  return endpoint(bookingId)
    .then((booking) => {
      dispatch(fetchCurrentSucceeded());
      dispatch(setBooking(booking));
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchCurrentFailed(error.message));
    });
};
